module.exports = __webpack_public_path__ + "media/promo/panasonic/images/soc-3-71a636fee3f0308c29094e8a70f152e2.svg";